import utils, {axiosWithAuth} from '@imt/vue-toolbox/src/utils';

export const getters = {
    isFeatureEnabled(state) {
        return (name) => {
            const flag = state.flags?.find(item => item?.name === name);

            return !!(flag && flag.enabled);
        };
    },
};

export const mutations = {
    SET_FEATURE_FLAGS(state, flags) {
        state.flags = flags;
    },
};

export const actions = {
    async fetchFeatureFlags({commit}) {
        try {
            const authAxios = axiosWithAuth(),
                response = await authAxios.get('/feature-flags/'),
                data = utils.dataFormatter.deserialize(response.data);

            commit('SET_FEATURE_FLAGS', data?.features || []);

            return data;
        } catch {
            commit('SET_FEATURE_FLAGS', []);

            return null;
        }
    },
};

export const state = () => {
    return {
        flags: null,
    };
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: state(),
};
